import { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Box, CircularProgress } from '@mui/material';
import { fetchMe, markAnonymous } from '../store/slices/authSlice.js';
import { getAccessToken } from '../api/axios.js';

/**
 * Жабык система (ТЗ 2.1): кирбеген колдонуучу эч бир бетти көрбөйт.
 * Токен болсо — колдонуучу серверден жүктөлөт (эсеп өчүрүлгөн болсо токен
 * иштебей калат — ТЗ 11.14), болбосо /login'ге.
 */
export default function RequireAuth({ children }) {
  const { status } = useSelector((s) => s.auth);
  const dispatch = useDispatch();
  const location = useLocation();

  useEffect(() => {
    if (status !== 'idle') return;
    if (getAccessToken()) dispatch(fetchMe());
    else dispatch(markAnonymous());
  }, [status, dispatch]);

  if (status === 'anonymous') {
    const next = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?next=${next}`} replace />;
  }

  if (status !== 'ready') {
    return (
      <Box sx={{ minHeight: '100vh', display: 'grid', placeItems: 'center' }}>
        <CircularProgress />
      </Box>
    );
  }
  return children;
}
